// extracted by mini-css-extract-plugin
module.exports = {"garden":"garden","living":"living","wedding":"wedding","shadow":"latest-topics-view_shadow__1qZll","heading":"latest-topics-view_heading__1WL9g"};